'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PLAN = exports.PLAN = 'plan';
var OFFER = exports.OFFER = 'offer';
var COMEMBERSHIP = exports.COMEMBERSHIP = 'co-membership';
var LIVE_ANNUAL = exports.LIVE_ANNUAL = 'annual';
var LIVE_TRIALS = exports.LIVE_TRIALS = ['trial', 'trial_no_hardware'];
var ALLOW_PREPAID_CARDS_PLANS = exports.ALLOW_PREPAID_CARDS_PLANS = ['CAN_TORONTO_STACK30CREDITCORPORATEPLAN_5800_5_3X_30CREDIT'];